module.exports = __webpack_public_path__ + "img/orange2.909b59be.jpg";